import {Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {ButtonModule} from '@primeng/button';

import {PaginatorModule} from '@primeng/paginator';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterLink} from '@angular/router';
import {AuthService} from '@app/auth/auth.service';
import {ToastService} from '@shared/third-part-modules/toastr/toast.service';


@Component({
  selector: 'auth-forgot-password',
  standalone: true,
  imports: [
    ButtonModule,
    PaginatorModule,
    ReactiveFormsModule,
    TranslatePipe,
    RouterLink
  ],
  templateUrl: './auth-forgot-password.component.html',
  styleUrl: './auth-forgot-password.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AuthForgotPasswordComponent {
  sendEmail = false
  isLoading = false;
  errorMessage: string | null = null;
  public _toastService = inject(ToastService);

  private fb = inject(FormBuilder)
  private passwordResetService = inject(AuthService)
  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  })

  onSubmit() {
    if (this.form.invalid) return;

    this.isLoading = true;
    this.errorMessage = null;

    this.passwordResetService.requestReset(this.form.value.email!).subscribe({
      next: () => {
        this.sendEmail = true;
        this.isLoading = false;
        this._toastService.success('', "TOAST.TOAST_check_email_sent");
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = err.error?.message || 'An error occurred. Please try again.';
      }
    });
  }
}
